// Soft radial-gradient shadow texture for the "floating object" look.
// Ported verbatim from oq-images/SceneBuilder.tsx.
import * as THREE from "three";

let cached: THREE.CanvasTexture | null = null;

export function getFloatShadowTexture(): THREE.CanvasTexture {
  if (cached) return cached;
  const size = 512;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const c = canvas.getContext("2d")!;
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2;
  const grad = c.createRadialGradient(cx, cy, 0, cx, cy, r);
  grad.addColorStop(0.0, "rgba(0,0,0,0.95)");
  grad.addColorStop(0.15, "rgba(0,0,0,0.78)");
  grad.addColorStop(0.3, "rgba(0,0,0,0.55)");
  grad.addColorStop(0.45, "rgba(0,0,0,0.35)");
  grad.addColorStop(0.6, "rgba(0,0,0,0.18)");
  grad.addColorStop(0.78, "rgba(0,0,0,0.07)");
  grad.addColorStop(0.9, "rgba(0,0,0,0.025)");
  grad.addColorStop(1.0, "rgba(0,0,0,0)");
  c.fillStyle = grad;
  c.fillRect(0, 0, size, size);
  const tex = new THREE.CanvasTexture(canvas);
  tex.minFilter = THREE.LinearMipmapLinearFilter;
  tex.magFilter = THREE.LinearFilter;
  tex.anisotropy = 16;
  tex.generateMipmaps = true;
  tex.needsUpdate = true;
  cached = tex;
  return tex;
}

/**
 * Attach a soft shadow plane underneath a placed instance. Returns the plane
 * mesh so callers can update its size/opacity later. The plane is added as a
 * child of the instance group at y ≈ 0 so it follows the instance around.
 */
export function attachFloatShadow(
  instance: THREE.Object3D,
  size: number,
  opacity: number,
): THREE.Mesh {
  const mat = new THREE.MeshBasicMaterial({
    map: getFloatShadowTexture(),
    transparent: true,
    depthWrite: false,
    opacity,
  });
  const plane = new THREE.Mesh(new THREE.PlaneGeometry(size, size), mat);
  plane.rotation.x = -Math.PI / 2;
  plane.position.y = 0.005;
  plane.name = "float-shadow";
  instance.add(plane);
  return plane;
}
